// src/services/performanceService.js
//
// Wraps /api/performance/* backend calls for HR and Employee views.
import { api } from './api';

export const performanceService = {
  // HR/Admin Actions
  getAllReviews: (status, cycle) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (cycle) params.append('cycle', cycle);
    const qs = params.toString();
    return api.get('/api/performance/' + (qs ? '?' + qs : ''));
  },

  createReview: (data) =>
    api.post('/api/performance/', data),

  submitManagerAssessment: (reviewId, data) =>
    api.put('/api/performance/' + reviewId + '/manager-assessment', data),

  deleteReview: (reviewId) =>
    api.delete('/api/performance/' + reviewId),

  // Employee Actions
  getMyReviews: () =>
    api.get('/api/performance/my'),

  getReviewDetails: (reviewId) =>
    api.get('/api/performance/' + reviewId),

  submitSelfAssessment: (reviewId, data) =>
    api.put('/api/performance/' + reviewId + '/self-assessment', data),

  getEmployeeHistory: (employeeId) =>
    api.get('/api/performance/employee/' + employeeId)
};